import InfiniteScroll from "react-infinite-scroll-component";
import ModalBox, { ModalBody, ModalHeader } from "../Modal/ModalBox";
import { useEffect, useRef, useState } from "react";
import { getAllNotifications } from "../../services/customer/notification";
import { TablePaginationProps } from "../../types/table";
import Loader from "../Loader";
import SvgIcon from "../../assets/icons/SvgIcon";
import moment from "moment";
import { LOCAL_STORAGE_KEYS, ROLES } from "../../constants";
import { getLocalStorage } from "../../utils";

const CustomerNotification = () => {
  const hasFetchedData = useRef(false);
  const userRole = getLocalStorage(LOCAL_STORAGE_KEYS.USER_ROLE);

  const [notification, setNotification] = useState(false);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [tablePagination, setTablePagination] = useState<TablePaginationProps>({
    pageNumber: 1,
    pageGroup: 10,
    sortOrder: "desc",
    sortKey: "created_at",
  });

  const handleOpenModel = () => {
    setNotification(true);
    handleFetchAllNotifications();
  };

  const handleApiData = (data: any) => {
    const { list, total_page, current_page } = data;

    if (list?.length) {
      setNotifications((prev) => [...prev, ...list]);

      setTablePagination((prev) => ({
        ...prev,
        pageNumber: prev.pageNumber + 1,
      }));

      if (current_page >= total_page) {
        setHasMore(false);
      }
    } else {
      setHasMore(false);
    }
  };

  const handleFetchAllNotifications = () => {
    getAllNotifications(handleApiData, {
      searchQuery: "",
      limit: tablePagination.pageGroup,
      page: tablePagination.pageNumber,
      sortOrder: tablePagination.sortOrder,
      sortField: tablePagination.sortKey,
    });
  };

  useEffect(() => {
    if (
      !hasFetchedData.current &&
      (userRole === ROLES.CUSTOMER || userRole === ROLES.SELLER)
    ) {
      handleFetchAllNotifications();
      hasFetchedData.current = true;
    }
  }, []);

  return (
    <>
      <button
        className="bg-gray-200 rounded-full p-1.5 sm:p-2.5 flex justify-between items-center gap-x-8 w-fit"
        type="button"
        onClick={handleOpenModel}
      >
        <SvgIcon iconName="notification" className="size-6" />
      </button>
      <ModalBox
        show={notification}
        closeModal={() => setNotification(false)}
        verticalAlign="Top"
        horizontalAlign="Right"
        classList={{
          modalWidth: "!p-0",
          modalClassName: "!m-0 !h-dvh",
          modalOutSideClassName: "!p-0 overflow-hidden",
        }}
      >
        <ModalHeader>
          <div className="flex justify-between items-center py-5 px-6">
            <h2 className="font-semibold text-lg">Notification</h2>
          </div>
          <hr />
        </ModalHeader>
        <ModalBody className="!py-0 overflow-hidden">
          <div className="h-[calc(100vh-75px)] overflow-auto">
            <InfiniteScroll
              dataLength={notifications?.length}
              next={handleFetchAllNotifications}
              hasMore={hasMore}
              height={880}
              loader={
                <div className="flex justify-center items-center py-4">
                  <Loader />
                </div>
              }
              endMessage={
                <div className="py-4">
                  <p className="font-bold text-center text-xl text-gray-400">
                    No more notifications
                  </p>
                </div>
              }
            >
              {notifications.map((notification, index) => (
                <div key={index} className="py-4 px-6 border-b border-gray-200">
                  <h2 className="text-xl font-medium text-gray-800">
                    {notification.title}
                  </h2>
                  <p className="text-base text-gray-600">{notification.body}</p>
                  <span className="text-xs text-gray-400">
                    {moment(notification.created_at).format(
                      "DD MMM YYYY HH:mm:ss"
                    )}
                  </span>
                </div>
              ))}
            </InfiniteScroll>
          </div>
        </ModalBody>
      </ModalBox>
    </>
  );
};

export default CustomerNotification;
